import React from 'react';
import FrmContenedor from "../LoginPostula/FrmContenedor";
import Modalform from "../../components/Modalform";
import { HeadInformation, ContainerInformation } from './styled.component';

export const InformaciónVacante = ({ _this, detallesS, horario, prestador }) => {
    return (
        <ContainerInformation>
            <HeadInformation >
                <h3 style={{ whiteSpace: "break-spaces" }}>
                    Puesto: {_this.state.puesto}
                </h3>
                <label id="Id_Vacante" className="Hide_All">
                    {_this.props.idvac}
                </label>
                <label id="Id_Zonificacion" className="Hide_All">
                    {_this.props.idzon}
                </label>
                <label id="prestador" className="Hide_All">
                    {prestador}
                </label>
                <label className="lbl_md_bl">
                    {" "}
                    Fecha de publicación:
                    {_this.state.datos !== null
                        ? _this.state.datos.data[0].fechaPublicacion !==
                            undefined
                            ? " " +
                            _this.state.datos.data[0].fechaPublicacion
                                .replace("T", " ")
                                .substring(0, 16)
                            : ""
                        : ""}
                </label>
            </HeadInformation>

            {
                _this.state.showLoginPostula && (
                    <FrmContenedor
                        handleClose={() =>
                            _this.setState({ showLoginPostula: false })
                        }
                        fncPostula={() => {
                            _this.postLogin();
                        }}
                    />
                )
            }
            <Modalform
                modulo={_this.state.moduloModal}
                idvacante={_this.props.idvac}
                btnsv={_this.state.nomBoton}
                datasource={_this.state.preguntas}
                onChangePropsModal={_this.onChangePropsModal}
                onChangebtnsv={_this.onChangebtnsv}
            />

            <div /*className="Ofrt_Hdr_Dtl_Bg"*/ id="Dv_Vac_Big">
                {typeof detallesS === "object" && detallesS.length > 0
                    ? _this.generaDvBg(detallesS, horario)
                    : null}
            </div>
        </ContainerInformation>
    )
}
